<template>
    <div v-if="previewImage" v-on:click="click" class="lightbox">
        <img :src="previewImage" alt="">
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    var keys = [32,33,34,35,36,37,38,39,40];

    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;  
    }

    function keydown(e) {
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                preventDefault(e);
                return;
            }
        }
    }

    function wheel(e) {
        preventDefault(e);
    }

    function disable_scroll() {
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', wheel, false);
        }
        window.onmousewheel = document.onmousewheel = wheel;
        document.onkeydown = keydown;
        disable_scroll_mobile();
    }

    function enable_scroll() {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', wheel, false);
        }
        window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
        enable_scroll_mobile();
    }

    // My improvement

    // MOBILE
    function disable_scroll_mobile(){
        document.addEventListener('touchmove',preventDefault, false);
    }
    function enable_scroll_mobile(){
        document.removeEventListener('touchmove',preventDefault, false);
    }

    /* 
     * The sun shall rise from the ashes and project
     * a lightbox upon its people
     */
    export default {
        computed: {
            ...mapGetters({
                previewImage: 'getLightboxImage'
            })
        },
        methods: {
            click() {
                this.$store.commit('setLightboxImage', null)
            }
        },
        watch: {
            previewImage(oldVal, newVal) {
                if(!newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .lightbox {
        height: 100vh;
        width: 100vw;
        background: rgba(0, 0, 0, 0.3);
        top: 0;
        left: 0;
        position: fixed;
        z-index: 10000;

        img {
            max-height: 80vh;
            max-width: 90vw;
            position: relative;
            left: 50%;
            top: 50%;
            transform-origin: left top;
            animation: 0.4s ease-out 0s 1 expand forwards;
        }
    }

    @keyframes expand {
        0% {
            transform: scale(0.7) translateX(-50%) translateY(-50%);
            opacity: 0.1;
        }
        100% {
            transform: scale(1) translateX(-50%) translateY(-50%);
            opacity: 1;
        }
    }

</style>